import React from 'react';

const StatCard = ({ value, label, icon: Icon }) => {
  return (
    <div 
      className="bg-card/50 backdrop-blur-sm border border-white/5 p-6 rounded-xl text-center hover:border-primary/30 transition-colors duration-300"
      data-aos="zoom-in"
    >
      {Icon && <Icon className="w-8 h-8 text-primary mx-auto mb-4 opacity-80" />}
      <h3 className="text-4xl font-serif font-bold text-primary mb-2">{value}</h3>
      <p className="text-sm text-muted-foreground uppercase tracking-wider font-medium">{label}</p>
    </div>
  );
};

export default StatCard;
